import Contact from '../components/Contact';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FloatingContactWidget from '../components/FloatingContactWidget';
import { useTheme } from '../contexts/ThemeContext';

const ContactPage = () => {
    const { isDark } = useTheme();
    return (
        <div className={`min-h-screen ${isDark ? 'bg-gray-900' : 'bg-white'} transition-colors duration-300`}>
            <Navbar />
            <div className="pt-20">
                <Contact />
            </div>
            <Footer />
            <FloatingContactWidget />
        </div>
    );
};

export default ContactPage;
